import React , {useState,useEffect} from 'react';
import { Link } from "react-router-dom";
import {useForm} from 'react-hook-form';
import clinicService from '../../../services/clinic.service';
import {toast} from 'react-toastify'
const ClinicAdd = () => {
    const [clinic, setClinic] = useState();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const {register, handleSubmit, formState:{errors}} = useForm();

    const onSubmit = (data) => {
        setLoading(true);
        setError(false);
        setSuccess(false);
        setMessage('');
      
        clinicService.addClinic(data)
            .then(res => {
                setLoading(false);
                setSuccess(true);
                setMessage(res.data.message);
                setClinic(res.data.clinic);
                toast.success("Clinic Created",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })

            })
            .catch(err => {
                setLoading(false);
                setError(true);
                setMessage(err.response.data.message);
                toast.error("Error while creating clinic",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            });
    };
    

    return ( 
        <>
            <div className="pagetitle d-flex justify-content-between">
                  <h1>Add New Clinic</h1>
                  <div>
                        <Link to="/clinics" className="btn btn-sm btn-success">Back</Link>
                        
                  </div>
             </div> 
             <section className="section clinicadd">
                <div className="row">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <form className="row g-3 mt-3" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="col-12">
                                        <label htmlFor="name" className="form-label">Clinic Name:</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("name", {required:true})}
                                        />
                                        {errors.name && <span className="text-danger">Clinic name is required</span>}
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                        
                                            {...register("email", {required:true})}
                                            />
                                        {errors.email && <span className="text-danger">Email is required</span>}
                                     </div>
                                    <div className="col-12">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("phone", {required:true})}
                                          />
                                        {errors.phone && <span className="text-danger">Phone is required</span>}
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="sms" className="form-label">SMS</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("sms", {required:true})}
                                      />
                                        {errors.sms && <span className="text-danger">SMS is required</span>}
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="logo" className="form-label">Logo Url</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("logo", {required:true})}
                                      />
                                        {errors.logo && <span className="text-danger">Logo Url is required</span>}
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="signature" className="form-label">Signature</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("signature", {required:true})}
                                         />
                                        {errors.signature && <span className="text-danger">Signature is required</span>}
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="assetName" className="form-label">Asset Name</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("assetName", {required:true})}
                                         />
                                        {errors.databaseName && <span className="text-danger">Database Name is required</span>}
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="website" className="form-label">Website</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            {...register("website", {required:true})}    
                                        />
                                        {errors.website && <span className="text-danger">Website is required</span>}
                                    </div>
                                    <div className="text-center">
                                        {error?<span className="text-danger">{message}</span>:''}
                                        {success?<span className="text-success">{message}</span>:''}
                                        {loading ? <button className="btn btn-sm btn-primary" disabled>Loading...</button> : <button className="btn btn-sm btn-secondary me-2" type="submit">Add</button>}
                                      
                                        <button type="reset" className="btn btn-sm btn-warning">Reset</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>   
             </section>

        </>
     );
}
 
export default ClinicAdd;